import { getBrandCapabilityStatus } from '@/features/hestia/queries/useBrandCapabilities'

/**
 * Master switch for restricting who may edit the website reviews block. While
 * off, the block behaves exactly as it always has — everyone can edit — so the
 * feature is inert until this is turned on. Once on, editing narrows to the SEO
 * operations allowlist ({@link REVIEWS_EDITABLE_FLAG}) and everyone else sees
 * the block read-only. Lives in the Hermes Unleash project; front-end gate only.
 */
export const REVIEWS_RESTRICTION_FLAG =
  'hermes.website-builder-reviews-restriction'

/**
 * Identifies the SEO operations team members allowed to edit the reviews block
 * once {@link REVIEWS_RESTRICTION_FLAG} is on. Membership is an allowlist on the
 * flag's strategy in the Hermes Unleash project — flip it there, not in code.
 * Consulted only while the restriction is active; on its own it does nothing.
 */
export const REVIEWS_EDITABLE_FLAG = 'hermes.website-builder-reviews-editable'

/** Namespace + capability identifying the reservations website section. */
export const RESERVATIONS_CAPABILITY = [
  'website-builder',
  'website-reservations',
] as const

/**
 * Whether the reservations website section is gated for the active brand: the
 * MiB display flag is on AND the backend reports the capability disabled. The
 * flag value is passed in so callers can source it from either the static
 * UnleashClient (block modules) or the reactive flag composable (components).
 * @param flagEnabled
 */
export const isReservationsGated = (flagEnabled: boolean): boolean =>
  flagEnabled &&
  getBrandCapabilityStatus(...RESERVATIONS_CAPABILITY) === 'disabled'
